<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <BandejaComponente
        :aplica-busqueda-fecha="true"
      :icono="icono"
      :titulo="titulo"
      :codigoTitulo="codigoTitulo"
      :subTitulo="subTitulo"
      :cifrasControl="cifrasControl"
      :datosTabla="datosTabla" 
      @_funcionExtra="getObtenerDatosBandeja"
      @_funcionExtra2="abrirModalObservaciones"
      @_actualizaFecha="actualizarFecha"
    ></BandejaComponente>

    <!-- Modal de observaciones-->

    <b-modal
        ref="observaciones"
        title="Observaciones Diagnóstico"
        hide-footer
    >
      <br />
      <h4 v-if="solicitud !== null" class="my-4 text-left">{{ solicitud.observacionesDiagnostico }}</h4>
      <br />
      <b-button
          class="mt-3"
          variant="outline-info"
          block
          @click="cerrarModal('observaciones')"
      >Cerrar</b-button
      >
      <br /><br/>
    </b-modal>

  </div>
</template>

<script>
import BandejaComponente from "../components/bandejas/BandejaComponente.vue";
import Swal from "sweetalert2";

export default {
  name: "BandejaClinicaHallazgo",
  components: {
    BandejaComponente,
  },
  props: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    fechaFin: "",
    fechaIncio: "",
    idEmpleado: null,
    idClinica: null,
    idUsuario: null,
    idPaciente: 0,
    datosTabla: [],
    encabezados: [
      {
        key: "nombreTipoSolicitud",
        label: "Tipo de Solicitud",
        sortable: true, 
      },
      {
        key: "pacientePresencial",
        label: "Paciente en Clínica",
        sortable: true,
        component: "PacientePresencialComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "LinkPacientePerfilComponente",
      },
      {
        key: "intIdNivelPTI",
        label: "Nivel PTI",
        sortable: true,
      },
      {
        key: "dtehoraInicio",
        label: "CDX inicia PTI",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },

      {
        key: "dtehoraFinal",
        label: "CDX termina PTI",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "nombreSolcitante",
        label: "Doctor solicitante en Clínica",
        sortable: true,
      },
      {
        key: "nombreDiagnosticador",
        label: "Diagnosticador de CDX",
        sortable: true,
      },
      {
        key: "observacionesDiagnostico",
        label: "Observaciones Diagnóstico",
        sortable: true,
        component: "BandejaObservacionesDiagnostico",
      },
      {
        key: "nombreEstatusCdx",
        label: "Estatus por CDX",
        sortable: true,
      },
      {
        key: "nombreEmbajador",
        label: "Embajador Presentador PTI Presuntivo",
        sortable: true, 
      },
      {
        key: "nombreEstatusClinica",
        label: "Estatus Embajador Clínica ",
        sortable: true,
      },
      {
        key: "idTipoSolicitud",
        label: "Solicitud rechazada Por Clínica",
        sortable: true,
        component: "SolicitudRechazadaComponente",
      },
      {
        key: "empleadosEspecialistas",
        label: "Empleados especialistas",
        sortable: true, 
        component: "ListaEspecialistasReplica",
      },
    ],

    cifrasControl: [
      {
        id: 1,
        nombre: "Solicitudes",
        cantidad: 0,
        icono: "star",
        layoutTabla: [],
      },
    ],
    icono: "fa fa-home",
    titulo: "Clínica",
    codigoTitulo: "BJ_01_CC",
    subTitulo: "Bandeja de solicitud en clínica ",
     resource: { 
      idEstatusSolicitud: 1, 
    },
    idEstatusPestañaSeleccionada : 1,
    solicitud: null
  }),
  methods: {
    getObtenerDatosBandeja() {
      
      this.showAlert();
      this.datosTabla = [];

      const params = {
        fechaFinal: this.fechaFin,
        fechaIncio: this.fechaInicio,
        idClinica: this.idClinica,
        idPaciente: this.idPaciente
      }

      this.$http
        .post(
          this.$api +
            "hallazgo/bandeja/obtenerDatosBandejaClinica", params

        )
        .then((response) => {
          //NO devuelve un array asi que no funciona validar isArray  
          this.datosTabla = response.data.data.listaResultados;
          this.cifrasControl[0].cantidad = this.datosTabla.length;
          this.cifrasControl[0].layoutTabla = this.encabezados;
          Swal.close();
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
          this.cifrasControl[0].cantidad = this.datosTabla.length;
          this.cifrasControl[0].layoutTabla = this.encabezados;
        });
 
    },
  
    actualizarFecha(fechaInicio, fechaFin, idPaciente) {
      if (fechaFin !== null && fechaInicio !== null){
        this.fechaInicio = fechaInicio;
        this.fechaFin = fechaFin;
      }
      this.idPaciente = idPaciente === null ? 0 : idPaciente;
      this.getObtenerDatosBandeja();
    },
        
    showAlert() {
      Swal.fire({
        title: "Se esta cargando la pagina.",
        html: "Espere por favor",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
    },

    abrirModalObservaciones(data){
      this.solicitud = data;
      this.$refs["observaciones"].show();
    },

    cerrarModal(nombre){
      this.$refs[nombre].hide();
      this.solicitud = null;
    },

  },
  mounted() {
    this.getObtenerDatosBandeja();    
    this.cifrasControl[0].cantidad = this.datosTabla.length;
    this.cifrasControl[0].layoutTabla = this.encabezados;
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.resource = {
      permiteCambiarDiagnosticador: false,
      idEstatusSolicitud: null,
      arrayDiagnosticadores: [],
    };
    this.idEmpleado = this.$localStorageService.getIdEmpleado();
    this.idClinica = this.$localStorageService.getIdClinica();
    this.idUsuario = this.$localStorageService.getIdUsuario();

    var dia1 = new Date();
    dia1.setDate(dia1.getDate() - 3);
    dia1.setHours(0, 0, 0, 0);
    this.fechaInicio = this.$moment(dia1)
      .utc()
      .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    var dia2 = new Date();
    dia2.setHours(23, 60, 59, 999);
    this.fechaFin = this.$moment(dia2)
      .utc()
      .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
  },
  computed: {},
};
</script>
